import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from './BreadcrumbBar';

const TOOLS = [
  {
    label:       'Social Media Post Generator',
    description: 'Erstelle automatisch Social Media Posts aus Artikeln oder Themen.',
    icon:        <AutoAwesomeIcon sx={{ fontSize: 36 }} color="primary" />,
    path:        '/marketing/post-generator',
  },
];

export default function Marketing() {
  const navigate = useNavigate();

    // Breadcrumbs
    useBreadcrumbs([
            { label: 'Marketing' },
                ]
    );

  return (
    <Box>
      <Typography variant="h4" component="h2" sx={{ mb: 1 }}>Marketing</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Wähle ein Tool aus.
      </Typography>

      <Grid container spacing={3}>
        {TOOLS.map((tool) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={tool.path}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardActionArea onClick={() => navigate(tool.path)} sx={{ height: '100%', p: 1 }}>
                <CardContent>
                  <Box sx={{ mb: 2 }}>{tool.icon}</Box>
                  <Typography variant="h6" sx={{ mb: 0.5 }}>{tool.label}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {tool.description}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'primary.main' }}>
                    <Typography variant="body2" fontWeight={600}>Öffnen</Typography>
                    <ArrowForwardIcon fontSize="small" />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}